import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { pureComponent } from 'lib/pureComponent';
import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { useDispatch } from 'react-redux';
import { OPEN_BARCODE_VIEWER } from 'store/actions';

interface Props {
  value: string;
  style?: StyleProp<ViewStyle>;
  showIconOnLeft?: boolean;
  numberOfLines?: number;
}

export const QRFieldDisplay: React.FC<Props> = pureComponent(
  ({ value, style, numberOfLines, showIconOnLeft }) => {
    const dispatch = useDispatch();
    const onAction = value
      ? () => dispatch(OPEN_BARCODE_VIEWER({ data: value }))
      : undefined;
    return (
      <CardRow
        value={value}
        valueNumberOfLines={numberOfLines}
        placeholder="No QR Code"
        actionIconLeft={ICONS.QRCodeLight}
        onActionLeft={showIconOnLeft ? onAction : undefined}
        actionIcon={ICONS.QRCodeLight}
        onAction={!showIconOnLeft ? onAction : undefined}
        style={style}
      />
    );
  },
);
